import { useContext } from 'react';
import { ModalActionsContext, ModalStateContext } from './ModalContexts';

export const useModalActions = () => {
    return useContext(ModalActionsContext);
};

export const useModalState = () => {
    return useContext(ModalStateContext);
};
